export default __webpack_public_path__ + "static/media/beige-wave.5ce16218.svg";